import { Box, Button } from '@mui/material';

const OS_OPTIONS = [
  { label: 'ALL', value: 'all' },
  { label: 'AOS', value: 'aos' },
  { label: 'IOS', value: 'ios' },
];

type Props = {
  selectedOs: string;
  onChange: (os: string) => void;
};

export default function OsFilterSelector({ selectedOs, onChange }: Props) {
  return (
    <Box display="flex" gap={0.75}>
      {OS_OPTIONS.map((opt) => (
        <Button
          key={opt.value}
          size="small"
          variant={selectedOs === opt.value ? 'contained' : 'outlined'}
          onClick={() => onChange(opt.value)}
          sx={{
            minWidth: 52,
            height: 36,
            fontWeight: 600,
            fontSize: '0.8rem',
            borderRadius: 2,
            ...(selectedOs === opt.value
              ? { backgroundColor: '#0044D2', borderColor: '#0044D2', '&:hover': { backgroundColor: '#0033a0' } }
              : { borderColor: '#e2e8f0', color: '#374151', '&:hover': { backgroundColor: '#f3f4f6', borderColor: '#cbd5e1' } }),
          }}
        >
          {opt.label}
        </Button>
      ))}
    </Box>
  );
}
